export enum FraudOutcome {
  LEGIT = 'legit',
  FRAUD = 'fraud',
  DEFAULT = 'default',
  ERROR = 'error',
}
